export const homePanelsSection = "/home-panels/";

export const homePanelsListPath = homePanelsSection;
export const homePanelsListUrl = homePanelsListPath;
